import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { HeaderComponent } from '../../shared/header/header.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LOCAL_STORAGE_KEYS, LocalStorageItemsService } from '../../services/local-storage-items.service';
import { ProductsComponent } from '../products/products.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [RouterModule,HeaderComponent, CommonModule, FormsModule,ProductsComponent,NgbTooltipModule],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss'
})
export class SidenavComponent {
  employee_details:any;
  isCollapsed: boolean = true;
  hoverExpanded = false;
  constructor(
    private localStorageService: LocalStorageItemsService
  ) { }

  ngOnInit(): void {
    // Initialization logic here
    this.localStorageService.getItem$(LOCAL_STORAGE_KEYS.LOGIN).subscribe((data) => {
      this.employee_details = data;
    });
  }

  toggleSidebar() {
    console.log(this.isCollapsed,'this.isCollapsedthis.isCollapsed')
  this.isCollapsed = !this.isCollapsed;
  // this.isCollapsed = true
}
onSidebarHover(isHovering: boolean) {
  // if (this.isCollapsed) {
  //   this.hoverExpanded = isHovering;
  // }
}
closeSidebar() {
  this.isCollapsed = true;
}
}
